var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclamatory = function SvgExclamatory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1,
    height: 1,
    viewBox: "0 0 14.3 14.3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Group 3806"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M7.15.65a6.5 6.5 0 1 1-6.5 6.5 6.5 6.5 0 0 1 6.5-6.5",
    "data-name": "Path 18907"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.3,
    d: "M7.151 4.477v3.108",
    "data-name": "Path 18908"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.6,
    d: "M7.146 9.821h.005",
    "data-name": "Path 18909"
  }))));
};
export default SvgExclamatory;